<template>
  <div class="taoBao">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox
        @query="queryList"
        placeholder="请输入关键字（大学名称/城市等）"
        v-model:inputValue="mydata.form.search"
      ></inputBox>
    </div>

    <!-- 模块2 -->
    <div class="box-online1">
      
      <!-- 省份筛选按钮 -->
      <subjectButton
        :filterButton="mydata.filterButton1"
        style="margin-bottom: 10px"
        :key="mydata.testKey0"
        @change="change1"
      ></subjectButton>
      <!-- 类型筛选 -->
      <subjectButton
        :filterButton="mydata.filterButton2"
        @change="change2"
        :key="mydata.testKey1"
      ></subjectButton>
      <!-- <div class="type-input">
        <p>城市：</p>
        <inputBox @query="queryList2" placeholder="请输入城市名称"></inputBox>
      </div> -->
    </div>
    <!--模块3  -->
    <div class="box-online2">
      <findAUniversityCards
        :path="mydata.path"
        v-for="(item, index) in mydata.articleListArr"
        :key="index"
        :info="item"
      >
      </findAUniversityCards>

      <!-- 空白内容组件 -->
      <glEmpty v-if="mydata.articleListArr.length === 0"></glEmpty>
    </div>
    <!--分页 -->
    <div class="gl-pagination">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false
// 缓存组件
import { defineComponent } from "vue"
export default defineComponent({
  name: 'findAUniversity',
  beforeRouteEnter(to,from,next){    
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (from.path !== '/layout/list/findAUniversityDetails') {
      fromOtherModule = true
      // console.log('来自其他模块');      
    }
    next()
  }
});
</script>




<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import subjectButton from "@/components/subjectButton/index.vue";
import bookBigListenCards from "@/components/bookBigListenCards/index.vue";
import findAUniversityCards from "@/components/findAUniversityCards/index.vue";
import { Document } from "@element-plus/icons-vue";

// import researchProjects from "@/components/researchProjects/index.vue";

// 引入接口
import { articleList } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";

import { reactive,onActivated } from "vue";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  path: "/layout/list/findAUniversityDetails",
  articleListArr: [], // 文章列表

  //筛选按钮
  filterButton1: {
    title: "地区",
    filter: JSON.parse(localStorage.getItem("provinceType")) ?? [],
  },
  filterButton2: {
    title: "类型",
    filter: JSON.parse(localStorage.getItem("schoolType")) ?? [],
  },
  testKey0: new Date().getTime() - Math.random()*10,
  testKey1: new Date().getTime() - Math.random()*100,

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 5, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
    university_type: "", // 大学类型
    province: "", // 省份
    city: "", // 市
  },
});


onActivated(()=>{
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
   // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
  mydata.path= "/layout/list/findAUniversityDetails",
  mydata.articleListArr= [], // 文章列表

  //筛选按钮
  mydata.filterButton1= {
    title: "地区",
    filter: JSON.parse(localStorage.getItem("provinceType")) ?? [],
  };
  mydata.filterButton2= {
    title: "类型",
    filter: JSON.parse(localStorage.getItem("schoolType")) ?? [],
  };
  mydata.testKey0= new Date().getTime() - Math.random()*10;
  mydata.testKey1= new Date().getTime() - Math.random()*100;

  mydata.pageObj= {
    currentPage: 1, // 当前页数
    pageSize: 5, // 每页条数
    total: 0, // 总的条数
  };
  mydata.form= {
    column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
    university_type: "", // 大学类型
    province: "", // 省份
    city: "", // 市
  };
  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  articleListFn()

  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false

  if (localStorage.getItem('v') !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1
    mydata.form.search = localStorage.getItem('v') // 获取本地存储并且赋值
    localStorage.removeItem('v')  // 赋值后立刻删除本地存储内容
   
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn()
    
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }

  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  // getSubject();
  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  // articleListFn()

})













// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  articleListFn();
}

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
    // console.log(res.data.list,"文章")
  });
}

// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1
  // 赋值
  mydata.form.search = inputValue;
  // 查询
  articleListFn();
}

// 查询列表
function queryList2(dict, inputValue) {
  // 赋值
  mydata.form.city = inputValue;
  // 查询
  articleListFn();
}

// 省份单选改变事件
function change1(val) {
  // 赋值
  mydata.form.province = val;
  // console.log(mydata.filterButton1,"121212")
  // 查询
  articleListFn();
}

// 类型单选框改变事件
function change2(val) {
  mydata.form.university_type = val;
  // 查询
  articleListFn();
}

// 查询
// articleListFn();
</script>

<style scoped lang="scss">
.taoBao {
  background-color: #f9f9f9;
  // padding-bottom: 40px;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }
  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
    }
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
  }
  //////模块2------搜索组件 和 按钮组件
  .box-online1 {
    background-color: #ffffff;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    overflow: hidden;
    //////按钮消失一个
    :deep(.el-button.el-button--primary.box2) {
      display: none;
    }
   
  }
  ///////模块3
  .box-online2 {
    // border:1px solid red;
    .big-box {
      margin-bottom: 16px;
      // border:1px solid blue;
    }
    .big-box:nth-last-of-type(1) {
      margin-bottom: 0px;
    }
  }
  //////模块4————分页
  .paging {
    // margin: 0 auto;
    margin-top: 40px;
    // margin-bottom: 40px;
    display: flex;
    justify-content: center;
    // border:1px solid red;

    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>
